<template>
  <div class="home-widgets-permanent">
    <ShareSocial />
    <QRCodeScanner />
    <GoogleFormModal />
    <div class="buttons-wrapper">
      <div class="centered" style="line-height:1.3em">
        {{ $t("shop.shops") }}
        <br />
        {{ $t("shop.restaurants") }}
        <br />
        {{ $t("shop.services") }}
      </div>
      <div v-if="showQR" class="buttons has-text-right is-pulled-right" style="padding-right:12px;">
        <a
          class="button is-rounded is-primary is-medium"
          style="padding:5px 15px"
          @click="openQRScanner"
        >
          <span class="icon" v-ripple>
            <i class="fa fa-qrcode fa-lg wiggle" />
          </span>
        </a>
      </div>
      <div class="buttons has-text-right is-pulled-right" style="padding-right:12px;">
        <a class="button is-rounded is-success is-medium" style="padding:5px 15px" @click="addShop">
          <span class="icon" v-ripple>
            <i class="fa fa-plus fa-lg wiggle" />
          </span>
        </a>
      </div>
      <div class="buttons is-pulled-left" style="padding-left:12px;">
        <a
          class="button is-rounded is-info is-medium"
          style="padding:5px 15px"
          @click="goto('shop?tab=shops')"
        >
          <span class="icon" v-ripple>
            <i class="fa fa-utensils fa-lg wiggle" />
          </span>
        </a>
      </div>
      <div class="buttons is-pulled-left" style="padding-left:12px;">
        <a
          class="button is-rounded is-link is-medium"
          style="padding:5px 15px"
          @click="goto('shop?tab=services')"
        >
          <span class="icon" v-ripple>
            <i class="fa fa-tools fa-lg wiggle" />
          </span>
        </a>
      </div>

      <!-- <div class="buttons is-centered">
        <button class="button is-warning">
          <i class="fa fa-sync-alt fa-2x" @click="refresh($event)" />
        </button>
        <button class="button is-warning" @click="share">
          <i class="fa fa-share-alt fa-2x" />
        </button>
        <button class="button is-warning" @click="tukWallet">
          <i class="fa fa-wallet fa-2x" />
        </button>
      </div>-->
    </div>
  </div>
</template>

<script>
import QRCodeScanner from "@/components/QRCodeScanner.vue";
import ShareSocial from "@/components/ShareSocial.vue";
import GoogleFormModal from "@/components/GoogleFormModal.vue";

export default {
  components: {
    QRCodeScanner,
    ShareSocial,
    GoogleFormModal
  },
  name: "HomeWidgetsPermanent",
  data() {
    return {};
  },
  computed: {
    showQR() {
      // return false; // for now don't show QR code reader
      if (this.isIOSApp()) return false;
      return true;
    }
  },
  mounted() {},
  methods: {
    // goToTransport() {
    //   this.$router.push("/tuktuk");
    // },
    addShop() {
      var url = this.$t("shop.sign-up-form");
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    tukWallet() {
      this.$swal({
        title: "Access your TUK QR Wallet!",
        text: "Coming soon...",
        timer: 1000
      });
    },
    openQRScanner() {
      //  ios: window.open("https://tukapp.co/qrscanner", "_blank");
      if (this.$store.getters.getOS === "iOS") {
        this.$swal({
          html: this.$t("qr.coming-soon-for-ios"), //`QR code scanner coming soon for iOS`,
          showConfirmButton: false,
          timer: 2500
        });
        return;
      }
      this.displayModal(".qr-scanner-modal");
    },
    openSchoolForm() {
      this.displayModal(".google-form-modal");
    },
    share() {
      this.displayModal(".share-social-modal");
    },
    refresh(e) {
      e.target.classList.add("fa-spin");
      setTimeout(function() {
        location.reload();
      }, 500);
    }
  }
};
</script>

<style scoped>
.centered {
  position: fixed;
  top: 18px;
  left: 50%;
  transform: translate(-50%, 0);
}
.buttons-wrapper {
  height: 65px;
  /* border-radius: 5px; */
  border-radius: 33px;
  margin: 15px;
  /* background-color: #9b9892; */
  background-color: white;
  /* border-width: 1px;
  border-color: #dbdbdb; */
  /* background-color: #ddd; */
}
.buttons {
  padding-top: 10px;
  padding-bottom: 5px;
}
/* .button { height: auto;} */
/* p {text-shadow: 0px 1px 2px #666;} */
.wiggle:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
</style>
